import { createSelector } from 'reselect';
import metaSelector from 'Selectors/metaSelector';

const widgetSelector = state => state.widgetState;
const userStateSelector = state => state.ustate;

export default createSelector(
	[ widgetSelector, metaSelector, userStateSelector ],
	( widget, meta, ustate ) => {
		return {
			widgetState: widget,
			meta: meta,
			ustate: ustate
		};
	}
);




// WEBPACK FOOTER //
// ./src/selectors/widgetsSelector.js